(function (root) {
  var CODE = /^[A-Za-z0-9_-]{1,64}$/;
  var STORAGE = 'affiliate';

  // The partner code of the address; empty unless it fits the narrow pattern.
  function refCode(search) {
    try {
      var value = new root.URLSearchParams(String(search || '')).get('ref') || '';
      return CODE.test(value) ? value : '';
    } catch (e) { return ''; }
  }

  // The coupon of the endpoint's answer; empty unless it fits the same pattern, so only a checked code reaches /discount/.
  function couponCode(value) {
    return typeof value === 'string' && CODE.test(value) ? value : '';
  }

  // The values the badge shows, all as text; null unless the answer carries a coupon and a discount.
  function badgeData(answer) {
    var data = answer && typeof answer === 'object' ? answer : {};
    var code = couponCode(data.coupon_code);
    var value = Number(data.discount_value);
    if (code === '' || !isFinite(value) || value <= 0) return null;
    var handle = typeof data.instagram_handle === 'string' ? data.instagram_handle.replace(/^@/, '').trim() : '';
    var name = typeof data.affiliate_name === 'string' ? data.affiliate_name.trim() : '';
    var avatar = typeof data.avatar_url === 'string' && /^https:\/\/[^\s"'<>\\]+$/.test(data.avatar_url) ? data.avatar_url : '';
    return {
      code: code,
      name: handle ? '@' + handle : name,
      type: data.discount_type === 'fixed_amount' ? 'amount' : 'percent',
      value: Math.round(value * 100) / 100,
      avatar: avatar,
    };
  }

  var api = { refCode: refCode, couponCode: couponCode, badgeData: badgeData, CODE: CODE };
  root.themeAffiliate = api;
  if (!root.document || typeof root.fetch !== 'function') return;

  var document = root.document;
  var script = document.currentScript;
  var config = script && script.dataset ? script.dataset : {};
  if (!config.endpoint || !config.brand || !config.discountUrl) return;
  var code = refCode(root.location.search);

  function store(data) {
    try { root.sessionStorage.setItem(STORAGE, JSON.stringify(data)); } catch (e) {}
  }
  function announce() {
    document.dispatchEvent(new root.CustomEvent('affiliate:ready'));
  }

  function track() {
    var mark = 'affiliate_click_' + code;
    try {
      if (root.sessionStorage.getItem(mark)) return;
      root.sessionStorage.setItem(mark, '1');
    } catch (e) {}
    root.fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ affiliate_ref: code, brand: config.brand, landing_url: root.location.href, referrer_url: document.referrer || null }),
      keepalive: true,
    })
      .then(function (response) { return response.json(); })
      .then(function (answer) {
        var data = badgeData(answer);
        if (!data) return;
        store(data);
        announce();
        return root.fetch(config.discountUrl + encodeURIComponent(data.code), { credentials: 'same-origin' });
      })
      .catch(function () {});
  }

  // The click asks for the coupon the visitor came for, so it runs without waiting for the banner: redeeming the
  // partner's discount is the service asked for, and the answer stays in this session's storage, no cookie.
  if (code) track();
  else announce();
})(window);
